import { Button, Icon } from '@ridi/rsg';
import classNames from 'classnames';
import { createElement } from 'react';

var FetchRetryBlock = function (_a) {
    var title = _a.title, _b = _a.description, description = _b === void 0 ? '다시 시도해주세요.' : _b, buttonClassName = _a.buttonClassName, onRetry = _a.onRetry;
    return (createElement("div", { className: "RUIFetchRetryBlock" },
        title && createElement("p", { className: "RUIFetchRetryBlock_Title" }, title),
        createElement("p", { className: "RUIFetchRetryBlock_Description" }, description),
        createElement(Button, { className: classNames('RUIFetchRetryBlock_RetryButton', buttonClassName), size: "large", outline: true, onClick: onRetry },
            createElement(Icon, { name: "redo_1", className: "RUIFetchRetryBlock_RetryButton_Icon" }),
            "\uB2E4\uC2DC \uC2DC\uB3C4")));
};

export { FetchRetryBlock };
//# sourceMappingURL=FetchRetryBlock.js.map



// WEBPACK FOOTER //
// /static/node_modules/@ridi/rsg/components/dist/FetchRetryBlock.js